import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { CONFIG, CONFIG_API_BE, URL_AKM } from "../../../../../config";
import { cekCookies } from "../../../../../actions";
import __ from "lodash";
import LoaderModal from "../../../../modal/LoaderModal";
import Navbar from "../../../navbar/Navbar";
import Sidebar from "../../../sidebar/Sidebar";
import eduprimeApi from "../../../../../apis/eduprimeApi";
import akmApi from "../../../../../apis/akmApi";

import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import SaveIcon from "@material-ui/icons/Save";
import ClearIcon from "@material-ui/icons/Clear";
import Button from "@material-ui/core/Button";

import ListPenjualanVoucher from "./ListPenjualanVoucher";
import PenjualanVoucherEnty from "../../../../../entity/PenjualanVoucherEnty";
import { Link } from "react-router-dom";
import { canSupplyStock } from "./stockAccess";

class AktivasiVoucher extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: false,
      isSnackbar: false,
      message: null,
      isFormPenjualanVoucher: false,
      listPaketProgram: [],
      selectedPenjualanVoucher: {},
      stokVoucher: 0,
      durasi: 1,
      statusVoucher: 0,
    };
  }

  async componentDidMount() {
    await this.props.cekCookies();
    if (!__.isEmpty(this.props.account)) {
      this.fetchPaketProgramAktif();
    }
  }

  componentDidUpdate() {
    // console.clear();
    // console.log(this.state);
  }

  handleSelectedPenjualanVoucher = (selected) => {
    this.setState({
      selectedPenjualanVoucher: selected,
      isFormPenjualanVoucher: true,
      stokVoucher: "-",
      nomorTransaksi: selected.nomorTransaksi,
      keterangan: selected.keterangan,
      hargaVoucher: selected.harga,
    });
  };

  render() {
    const { isFetching, nomorTransaksi, listPaketProgram, stokVoucher, jumlahVoucher, hargaVoucher, keterangan, isFormPenjualanVoucher } = this.state;
    return (
      <div className="wrapper">
        <LoaderModal isFetching={isFetching} />
        <Sidebar account={this.props.account} />
        <div id="content" style={{ paddingBottom: "50px" }}>
          {this.loadSnackbar()}
          <Navbar title={"Penjualan Voucher"} />
          {canSupplyStock(this.props.account) && <Button component={Link} to="/stokvoucher" color="primary" variant="outlined" style={{ marginBottom: 20 }}>Tambah Stok Voucher</Button>}
          {isFormPenjualanVoucher ? (
            this.loadFormPenjualanVoucher()
          ) : (
            <ListPenjualanVoucher
              handleSelectedPenjualanVoucher={(selected) => this.handleSelectedPenjualanVoucher(selected)}
              handleChangeIsFormPenjualanVoucher={() => this.setState({ isFormPenjualanVoucher: true })}
            />
          )}
        </div>
      </div>
    );
  }

  loadFormPenjualanVoucher = () => {
    const kodeJenisVoucherList = [
      { label: "PREMIUM", value: "PREMIUM" },
      { label: "PSEP", value: "PSEP" },
      { label: "EVENT", value: "EVENT" },
    ];
    const statusVoucher = [
      { label: "Open", value: 1 },
      { label: "Close", value: 2 },
    ];
    const durasiVoucher = [
      { label: "1 Bulan", value: 1 },
      { label: "2 Bulan", value: 2 },
      { label: "3 Bulan", value: 3 },
      { label: "6 Bulan", value: 6 },
      { label: "12 Bulan", value: 12 },
    ];

    const { durasi, kodeJenisVoucher, idPaketProgram, nomorTransaksi, listPaketProgram, stokVoucher, jumlahVoucher, hargaVoucher, keterangan, selectedPenjualanVoucher } = this.state;
    return (
      <form onSubmit={this.handleSubmit}>
        <Grid container spacing={5}>
          <Grid item xs={6}>
            <TextField value={nomorTransaksi} id="nomorTransaksi" label="Nomor Transaksi" placeholder="Masukkan Nomor Transaksi" onChange={this.onChangeTextField} required />
          </Grid>
          <Grid item xs={6}>
            <Autocomplete
              id="idPaketProgram"
              options={listPaketProgram}
              value={selectedPenjualanVoucher.idPenjualanVoucher ? listPaketProgram.find((item) => item.value === selectedPenjualanVoucher.idPaketProgram) : idPaketProgram}
              getOptionLabel={(option) => option.label}
              renderInput={(params) => <TextField {...params} label="Paket Program" required />}
              onChange={this.onChangeAutoComplete}
              disableClearable={true}
              required
              disabled={selectedPenjualanVoucher.idPenjualanVoucher ? true : false}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            &nbsp;
          </Grid>
        </Grid>

        <Grid container spacing={5}>
          <Grid item xs={3}>
            <Autocomplete
              id="kodeJenisVoucher"
              options={kodeJenisVoucherList}
              value={selectedPenjualanVoucher.idPenjualanVoucher ? kodeJenisVoucherList.find((item) => item.value === selectedPenjualanVoucher.kodeJenisVoucher) : kodeJenisVoucher}
              getOptionLabel={(option) => option.label}
              renderInput={(params) => <TextField {...params} label="Jenis Voucher" required />}
              onChange={this.onChangeAutoComplete}
              disableClearable={true}
              disabled={selectedPenjualanVoucher.idPenjualanVoucher ? true : false}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField value={stokVoucher} id="stokVoucher" label="Voucher Tersedia" disabled={true} />
          </Grid>
          <Grid item xs={3}>
            <Autocomplete
              id="durasi"
              options={durasiVoucher}
              //   value={selectedPenjualanVoucher.idPenjualanVoucher ? durasiVoucher.find((item) => item.value === selectedPenjualanVoucher.durasi) : durasi}
              getOptionLabel={(option) => option.label}
              defaultValue={durasiVoucher[0]}
              renderInput={(params) => <TextField {...params} label="Durasi Voucher Aktif" required />}
              onChange={this.onChangeAutoComplete}
              disableClearable={true}
              disabled={selectedPenjualanVoucher.idPenjualanVoucher ? true : false}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            &nbsp;
          </Grid>
        </Grid>

        <Grid container spacing={5}>
          <Grid item xs={3}>
            <TextField
              value={jumlahVoucher}
              id="jumlahVoucher"
              label="Jumlah Voucher"
              placeholder="Jumlah Beli Voucher"
              required
              onChange={this.onChangeTextField}
              type="number"
              disabled={selectedPenjualanVoucher.idPenjualanVoucher ? true : false}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField value={hargaVoucher} id="hargaVoucher" label="Harga Voucher" placeholder="Masukkan Harga Voucher" required onChange={this.onChangeTextField} type="number" min={0} />
          </Grid>
          <Grid item xs={3}>
            <Autocomplete
              id="statusVoucher"
              options={statusVoucher}
              value={selectedPenjualanVoucher.idPenjualanVoucher ? statusVoucher.find((item) => item.value === selectedPenjualanVoucher.statusVoucher) : statusVoucher[0]}
              getOptionLabel={(option) => option.label}
              defaultValue={statusVoucher[0]}
              renderInput={(params) => <TextField {...params} label="Status Voucher" required />}
              onChange={this.onChangeAutoComplete}
              disableClearable={true}
              disabled
            />
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            &nbsp;
          </Grid>
        </Grid>

        <Grid container spacing={5}>
          <Grid item xs={12}>
            <TextField
              value={keterangan}
              id="keterangan"
              label="Keterangan Pembelian"
              multiline
              rows={3}
              placeholder="Keterangan Pembelian Voucher ..."
              variant="outlined"
              onChange={this.onChangeTextField}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            &nbsp;
          </Grid>
        </Grid>

        <Grid container spacing={5}>
          <Grid item xs={12}>
            <Button type="submit" variant="outlined" color="primary" style={{ float: "right" }}>
              <SaveIcon /> &nbsp; Simpan
            </Button>
            <Button type="button" variant="outlined" color="secondary" onClick={() => this.handleResetAll()} style={{ float: "right" }}>
              <ClearIcon /> &nbsp; cancel
            </Button>
            &nbsp;
          </Grid>
        </Grid>
      </form>
    );
  };

  onChangeAutoComplete = async (e, val) => {
    const data = e.target.id.split("-");
    this.setState({ [data[0]]: val.value });
    console.log(data, val);

    switch (data[0]) {
      case "kodeJenisVoucher":
        this.fetchJenisVoucherAktivasi(val.value);
        break;

      default:
        break;
    }
  };

  onChangeTextField = async (e) => {
    const id = e.target.id;
    const val = e.target.value;

    if (id === "jumlahVoucher") {
      if (val > this.state.stokVoucher) {
        this.setState({
          isSnackbar: true,
          message: "Stok voucher tidak mencukupi....",
          codeError: "EP-001",
        });
        return;
      }
    }

    this.setState({ [id]: val });
  };

  fetchPaketProgramAktif = async (e) => {
    this.setState({ isFetching: true });
    const response = await akmApi.get(URL_AKM.FETCH_PAKET_PROGRAM_ALL).catch(function (error) {
      this.setState({ error });
    });

    if (response) {
      if (response.data.errorSchema.errorCode == URL_AKM.SUCCESS_ERROR_CODE) {
        response.data.data.map((val, i) => {
          const dataProgram = { value: val.idPaketProgram, label: val.namaProgram };
          this.state.listPaketProgram.push(dataProgram);
        });
      }
    }
    this.setState({ isFetching: false });
  };

  fetchJenisVoucherAktivasi = async (event) => {
    this.setState({ isFetching: true });
    const response = await akmApi.get(URL_AKM.FETCH_STOK_VOUCHER_BY_KODE_TIPE + event).catch(function (error) {
      this.setState({ error });
    });

    if (response) {
      if (response.data.errorSchema.errorCode == URL_AKM.SUCCESS_ERROR_CODE) {
        this.setState({
          stokVoucher: response.data.data.jumVoucher,
          codeError: response.data.errorSchema.errorCode,
        });
      } else {
        this.setState({
          isSnackbar: true,
          stokVoucher: 0,
          codeError: response.data.errorSchema.errorCode,
          message: response.data.errorSchema.errorMessage,
        });
      }
    }
    this.setState({ isFetching: false });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ isFetching: true });
    console.clear();
    console.groupCollapsed("SUBMIT");
    console.log(this.state);
    console.groupEnd();

    var response;
    if (this.state.selectedPenjualanVoucher.idPenjualanVoucher == null) {
      response = await akmApi
        .post(URL_AKM.SIMPAN_PENJUALAN_VOUCHER, {
          ...PenjualanVoucherEnty,
          idPaketProgram: this.state.idPaketProgram,
          nomorTransaksi: this.state.nomorTransaksi,
          kodeJenisVoucher: this.state.kodeJenisVoucher,
          durasi: this.state.durasi,
          jumlahVoucher: this.state.jumlahVoucher,
          harga: this.state.hargaVoucher,
          status: this.state.statusVoucher,
          keterangan: this.state.keterangan,
        })
        .catch(function (error) {
          this.setState({ error });
        });
    } else {
      response = await akmApi
        .put(URL_AKM.UPDATE_PENJUALAN_VOUCHER + this.state.selectedPenjualanVoucher.idPenjualanVoucher, {
          ...PenjualanVoucherEnty,
          nomorTransaksi: this.state.nomorTransaksi,
          keterangan: this.state.keterangan,
          harga: this.state.hargaVoucher,
        })
        .catch(function (error) {
          this.setState({ error });
        });
    }

    if (response) {
      if (response.data.errorSchema.errorCode == URL_AKM.SUCCESS_ERROR_CODE) {
        this.setState({
          isSnackbar: true,
          codeError: response.data.errorSchema.errorCode,
          message: response.data.errorSchema.errorMessage,
          isFormPenjualanVoucher: false,
        });
        this.handleResetAll();
      } else {
        this.setState({
          isSnackbar: true,
          stokVoucher: 0,
          codeError: response.data.errorSchema.errorCode,
          message: response.data.errorSchema.errorMessage,
        });
      }
    }
    this.setState({ isFetching: false });
  };

  handleResetAll = () => {
    this.setState({
      stokVoucher: null,
      durasiVoucher: null,
      jumlahVoucher: null,
      hargaVoucher: null,
      statusVoucher: 0,
      keterangan: null,
      nomorTransaksi: null,
      selectedPenjualanVoucher: {},
      isFormPenjualanVoucher: false,
    });
  };

  loadSnackbar = () => {
    const { isSnackbar, codeError, message } = this.state;
    return (
      <Snackbar
        anchorOrigin={{
          vertical: "",
          horizontal: "",
        }}
        open={isSnackbar}
        autoHideDuration={5000}
        onClose={() => this.setState({ isSnackbar: false })}
      >
        <Alert onClose={() => this.setState({ isSnackbar: false })} severity={codeError == "EP-000" ? "success" : "error"}>
          <b style={{ fontSize: 20 }}>{message}</b>
        </Alert>
      </Snackbar>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    account: state.account,
  };
};

export default connect(mapStateToProps, { cekCookies })(AktivasiVoucher);
